import * as React from 'react';
import { useMenuItem } from '../item/useMenuItem.js';
import { useControlled } from '../../utils/useControlled.js';
import { mergeProps } from '../../merge-props/index.js';
export function useMenuCheckboxItem(params) {
  const {
    checked: checkedProp,
    defaultChecked,
    onCheckedChange,
    ...other
  } = params;
  const [checked, setChecked] = useControlled({
    controlled: checkedProp,
    default: defaultChecked ?? false,
    name: 'MenuCheckboxItem',
    state: 'checked'
  });
  const {
    getItemProps: getMenuItemProps,
    ...menuItem
  } = useMenuItem(other);
  const getItemProps = React.useCallback(externalProps => {
    return mergeProps({
      role: 'menuitemcheckbox',
      'aria-checked': checked,
      onClick: event => {
        setChecked(currentlyChecked => !currentlyChecked);
        onCheckedChange?.(!checked, event.nativeEvent);
      }
    }, externalProps, getMenuItemProps);
  }, [checked, getMenuItemProps, onCheckedChange, setChecked]);
  return React.useMemo(() => ({
    ...menuItem,
    getItemProps,
    checked
  }), [checked, getItemProps, menuItem]);
}